import { Box, styled } from '@mui/material';

export const StyledScheduledTurnaroundBox = styled(Box)`
    display: flex;
    position: absolute;
    flex-direction: row;
    margin-top: 43px;
    justify-content: center;
    align-items: center;
    opacity: 50%;

    &.selected {
        opacity: 100%;
    }
`;

export const StyledScheduledTurnaroundZoneBox = styled(Box)`
    background-color: white;
    color: black;
    border-radius: 5px;
    height: 12px;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

export const StyledScheduledTurnaroundFlightNumberBox = styled(Box)`
    font-weight: 500;
    font-size: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
`;

export const StyledScheduledMinTimeBetweenUseBox = styled(Box)`
    height: 20px;
    display: flex;
    align-items: center;
`;
